export { default } from '@features/post'
